export default {
  // eslint-disable-next-line no-unused-vars
  SET_AUTH_USER(state, payload) {
    if (payload && payload.nome) {
      const { nome, empresaRazaoSocial } = payload
      // eslint-disable-next-line prefer-destructuring
      payload.primeiroNome = nome.split(' ')[0]
      // eslint-disable-next-line prefer-destructuring
      payload.empresaResumida = empresaRazaoSocial
        .toUpperCase()
        .replace('CONDOMÍNIO', '')
        .replace('CONDOMINIO', '')
        .replace('LTDA', '')
        .replace('-', '')
        .trim()
        .substring(0, 20)
    }
    localStorage.setItem('authUser', JSON.stringify(payload))
  },
}
